module.exports = __webpack_public_path__ + "img/page_banner_1.9d686382.png";